$(document).ready(function () {
    $('body').removeClass('noscript');
});
